import * as React from "react";
import useTelemetry from "../../utils/Telemetry/useTelemetry";

export const L2Container = () => {
  const telemetry = useTelemetry();
  React.useEffect(() => {
    telemetry.sendPageInitEvent();
  }, []);

  return <div id="l2-page"></div>;
};
